<!-- =========== MAIN PAGE CONTAINER ============== -->
<div
	class="main-container"
	[ngStyle]="{
		'background-image': showBackground ? 'url(../../../../assets/images/Trb-latest-svg/Background-img.svg)' : 'none',
	}"
	style="display: flex; flex-direction: column; height: 100%; background-repeat: no-repeat; background-size: cover; background-position: center"
>
	<!--
		The page actions (share / favorite / event details) live in the breadcrumb bar wherever there
		is one, and move up into the navbar on the pages that suppress it — so they are reachable
		everywhere without ever appearing twice.
	-->
	<app-top-navbar [sideBarExpanded]="sideBarExpanded" [showPageActions]="!showBreadcrumb"></app-top-navbar>

	<!-- Content row: body column + chat sidecar (sidecar is here so it only pushes body, not navbar) -->
	<div class="content-row" [class.sidecar-open]="chatSidecarOpen && !chatSidecarFullscreen" [class.sidecar-fullscreen]="chatSidecarFullscreen">
		<div class="body-column">
			<div *ngIf="showBreadcrumb" style="height: 50px; margin: 20px 30px 20px 30px">
				<app-breadcrumb (showHideSpinner)="showHideSpinner($event)"></app-breadcrumb>
			</div>

			<div class="body-container">
				<ngx-spinner [name]="contentContainerSpinner" bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="line-spin-fade" [fullScreen]="true">
					<p style="color: white">Loading...</p>
				</ngx-spinner>
				<ng-container #dynamicComponent></ng-container>
			</div>

			<!-- ============ FOOTER COMPONENT STYLE ================== -->
			<app-footer></app-footer>
		</div>
		<app-chat-sidecar
			[isOpen]="chatSidecarOpen"
			[isFullscreen]="chatSidecarFullscreen"
			(openChange)="chatSidecarService.setOpen($event)"
			(fullscreenChange)="chatSidecarService.setFullscreen($event)"
		></app-chat-sidecar>
	</div>
</div>
